import { PetBreed } from '../Breed'

export class GetPetBreedResponse {
  /** (Opcional): Lista de objetos que contienen información sobre las actividades. */
  breeds: PetBreed[]

  constructor(data: any = {}) {
    this.breeds = data.breeds?.map((b: any) => new PetBreed(b))
  }
}
